import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.user.facebook.post,
    props.user.facebook.tasks,
    (post, tasks) => {
        return {
            post,
            tasks
        }
    }
)